const config = require('./config');

const postUrls = (tipo, body, token) => {
  return fetch(`${config.URL_BACKEND}/etiqueta/urls?tipo=${tipo}`, {
    method: 'POST',
    headers: {
      "Content-Type": "application/json",
      "User-Token": token
    },
    body: JSON.stringify(body)
  });
};

const getDownload = (query) => {
  return fetch(`${config.URL_BACKEND}/preSignedUrl/download?key=${query.key}&UserToken=${query.UserToken}`, {
    method: 'GET',
    headers: { "Content-Type": "application/json" },
  });
};

module.exports = {
  postUrls,
  getDownload
};